<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 17q.4 0 .7-.3t.3-.7l-.3-.7-.7-.3-.7.3-.3.7q0 .4.3.7t.7.3m-1-4h2V7h-2zm1 9a10 10 0 0 1-7-3A10 10 0 0 1 2.7 8.2 10 10 0 0 1 8 2.8Q9.9 2 12 2a10 10 0 0 1 7 3 10 10 0 0 1 3 7 10 10 0 0 1-3 7 10 10 0 0 1-7 3"
    />
  </svg>
</template>
